import { ReactNode } from 'react';

type PageLayoutHeaderContent = {
  title?: ReactNode;
  headerBreadcrumbs?: ReactNode;
  headerTabs?: ReactNode;
  headerContent?: ReactNode;
  subheader?: ReactNode;
  isLoading?: boolean;
};

export const hasPageLayoutHeader = ({
  title,
  headerBreadcrumbs,
  headerTabs,
  headerContent,
  subheader,
  isLoading,
}: PageLayoutHeaderContent): boolean =>
  Boolean(
    title ||
      headerBreadcrumbs ||
      headerTabs ||
      headerContent ||
      subheader ||
      isLoading,
  );
